import { AnomalyApi, GetAnomaliesQueryParams } from '@api/twin/AnomalyApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { anomalyQueryKeys } from '../query-keys';

export const useGetAnomalies = (projectId: number, anomaliesQueryParams: GetAnomaliesQueryParams) => {
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;
  const anomalyApi = AnomalyApi(client);

  return useQuery({
    queryKey: anomalyQueryKeys.anomalies(projectId, anomaliesQueryParams),
    queryFn: () => {
      return anomalyApi.getAnomalies(projectId, anomaliesQueryParams);
    },
    placeholderData: keepPreviousData,
    gcTime: 1000 * 60 * 30,
    staleTime: 1000 * 60 * 5,
  });
};
